module.exports = __webpack_public_path__ + "static/media/sqsSa_sm5.91f1b0c2.jpeg";